module.exports = __webpack_public_path__ + "media/images/common/ordered_product-68fbaa458371f24608c6de8576839cc0.png";